import React, { Fragment, useState } from 'react';
import { createPortal } from 'react-dom';

import {
    getTeamUsersUrl,
    getTeamBillingUrl,
    getTemplatesUrl,
    getArchivedPagesSearchViewUrl,
} from '../../utilities/urlHelper';
import getTeamName from '../../utilities/teamNameHelper';

import {
    canUpdateTeam,
    canEditTemplates,
    canViewArchived,
} from '../../utilities/permissionsUtilities';
import EditTeamHomeModal from './EditTeamHomeModal';

const SidebarDropdown = () => {
    const [showEditTeamHomeModal, setShowEditTeamHomeModal] = useState(false);
    return (
        <Fragment>
            <div className="dropdown dropdown-left-aligned team-dropdown" data-disclosure>
                <button className="dropdown-link" type="button" aria-label="open team options dropdown">
                    <img className="left-nav__icon" src={window.teamProfileImage} width="24" height="24" style={{ backgroundColor: 'transparent' }} alt="Team logo" />
                    <span className="elipsis">{ getTeamName() }</span>
                    <span className="dropdown-carat" />
                </button>
                <div data-details className="dropdown-overlay" style={{ display: 'none' }} />
                <div data-details className="dropdown-content" style={{ display: 'none' }}>
                    <div className="dropdown-content-section">
                        <a href={getTeamUsersUrl()} className="dropdown-option">Team settings</a>
                        {canUpdateTeam() && <a href={getTeamBillingUrl()} className="dropdown-option">Billing</a>}
                    </div>
                    <div className="dropdown-content-section">
                        {canEditTemplates() && <a href={getTemplatesUrl()} className="dropdown-option">Templates</a>}
                        {canViewArchived() && <a href={getArchivedPagesSearchViewUrl()} className="dropdown-option">Archived content</a>}
                    </div>
                    {canUpdateTeam() && <a className="dropdown-option do-cancel">Cancel</a>}
                </div>
            </div>
            { showEditTeamHomeModal
                && createPortal(
                    <EditTeamHomeModal closeModal={() => setShowEditTeamHomeModal(false)} />,
                    document.body,
                )}
        </Fragment>
    );
};

const SidebarHeader = (props) => (
    <div className="left-nav__header-section">
        <SidebarDropdown />
        <button className="left-nav-toggle" type="button" title="Hide sidebar" data-tippy-content="Hide sidebar" data-tippy-placement="bottom" aria-label="Hide sidebar">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.75 2L10.75 14" stroke="currentcolor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M14.25 5V11C14.25 12.7949 12.7949 14.25 11 14.25H5C3.20507 14.25 1.75 12.7949 1.75 11V5C1.75 3.20507 3.20507 1.75 5 1.75H11C12.7949 1.75 14.25 3.20507 14.25 5Z" stroke="currentcolor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M7.25 6L5.25 8L7.25 10" stroke="currentcolor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </button>
    </div>
);

export default SidebarHeader;
